import { Routes } from "@angular/router";
import { AuthGuard } from "../../../../_services/auth/auth.guard";
import { AuthDashboardComponent } from "@app/components/dashboard/auth-dashboard/auth-dashboard.component";
import { AddlicenceComponent } from "@app/components/addlicence/addlicence.component";
import { RoleComponent } from "@app/components/role/role.component";
import { AddRoleComponent } from "@app/components/role/add-role/add-role.component";

export const DASHBOARD_ROUTES: Routes = [
  {
    canActivate: [AuthGuard],
    path: '',
    component: AuthDashboardComponent,
    data: {
      claimType: '',
      breadcrumb: "DASHBOARD",
      title: "DASHBOARD",
      headerTitle: "DASHBOARD",
      type: 'mainmenu',
      icon: 'home',
      active: false,
      path: '/dashboard'
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'add-licence',
    component: AddlicenceComponent,
    data: {
      claimType: '',
      breadcrumb: "ADD_LICENCE",
      title: "ADD_LICENCE",
      headerTitle: "LICENCE",
      type: 'link',
      icon: 'key',
      active: false,
    },
  },
  // {
  //   path: '',
  //   data: {
  //     title: 'USER',
  //     type: 'sub',
  //     active: false,
  //     icon: 'users',
  //     canActivate: [AuthGuard],
  //   },
  //   children: [
  //     {
  //       path: 'role',
  //       component: RoleComponent,
  //       data: {
  //         claimType: 'ROLES_VIEW',
  //         breadcrumb: "ROLE",
  //         title: "ROLE",
  //         type: 'link',
  //         icon: 'navigation',
  //         path: "role",
  //         headerTitle: "USER_MANAGEMENT",
  //       }
  //     },
  //     {
  //       path: 'add-role',
  //       component: AddRoleComponent,
  //       data: {
  //         claimType: 'ROLES_ADD',
  //         breadcrumb: "ADD_ROLE",
  //         title: "ADD_ROLE",
  //         headerTitle: "ROLE",
  //         icon: 'navigation',
  //         path: "add-role",
  //       }
  //     },
  //     // {
  //     //   path: 'role/:id',
  //     //   component: AddRoleComponent,
  //     //   data: {
  //     //     headerTitle: "ROLE",
  //     //     claimType: 'ROLES_UPDATE',
  //     //     breadcrumb: "UPDATE_ROLE",
  //     //     title: "UPDATE_ROLE",
  //     //   },
  //     // },
  //   ]
  // },
];